export default __webpack_public_path__ + "static/icon-mark-4ba2450b71e973e57b09e6b16fdabf44.png";